<script>
  export let user;
  export let onLogEditor;
  export let onLogReviewer;
  export let onEdit;
  export let onRemove;
  export let onChangeRole;
  export let onEmail;

  import { dictionary } from "../utils/stores.js";

  let dict;

  const unsubscribe = dictionary.subscribe((value) => {
    dict = value;
  });

  let userIcon = "/images/revista/user.svg";

  $: {
    userIcon = "/images/revista/user.svg";
    if (user.rol === "EditorJefe") {
      userIcon = "/images/revista/user-ce.svg";
    }
    if (user.rol === "Editor") {
      userIcon = "/images/revista/user-e.svg";
    }
  }
</script>

<style>
  td.options {
    text-align: right;
    width: 150px;
  }

  td.options img {
    width: 20px;
    height: 20px;
    margin-left: 5px;
    cursor: pointer;
  }

  td.user {
    width: 85px;
    text-align: center;
  }

  td.user img {
    width: 30px;
    height: 30px;
  }

  td.role {
    width: 200px;
    text-align: center;
  }

  td.role select {
    width: 75%;
  }

  td.info {
    padding-bottom: 1px;
    padding-top: 1px;
  }

  tr.noline {
    border-top-width: 0px;
  }

  tr.first td {
    padding-top: 10px;
  }

  tr.last td {
    padding-bottom: 10px;
  }

  td.name {
    color: #3375ec;
    font-weight: bold;
  }

  td.extra {
    font-size: 13px;
  }

  td.icons img {
    width: 20px;
    height: 20px;
  }
</style>

<tr class="first">
  <td rowspan="4" class="user">
    <img class="user" src={userIcon} alt="User Icon" />
  </td>
  <td class="info name">
    {user.nombre}
    {user.apellido1}
    {user.apellido2}
    -
    {user.firma}
  </td>
  <td rowspan="4" class="role">
    {#if !user.soyYo}
      <select bind:value={user.rol} on:change={onChangeRole}>
        <option value="EditorJefe">{dict['editorJefe']}</option>
        <option value="Editor">{dict['editor']}</option>
        <option value="Usuario">{dict['usuario']}</option>
      </select>
    {/if}
  </td>
  <td rowspan="4" class="options">
    <img
      title={dict['enviarEmail']}
      src="/images/revista/email.svg"
      alt="Email Icon"
      on:click={onEmail} />
    {#if user.rol === 'EditorJefe' || user.rol === 'Editor'}
      <img
        title={dict['historialEditor']}
        src="/images/revista/document-editor.svg"
        alt="Editor Log Icon"
        on:click={onLogEditor} />
    {/if}
    {#if user.esRevisor}
      <img
        title={dict['historialRevisor']}
        src="/images/revista/document-reviewer.svg"
        alt="Reviewer Log Icon"
        on:click={onLogReviewer} />
    {/if}
    {#if !user.soyYo}
      <img
        title={dict['editar']}
        src="/images/revista/edit.svg"
        alt="Edit Icon"
        on:click={onEdit} />
      <img
        title={dict['eliminar']}
        src="/images/revista/close.svg"
        alt="Remove Icon"
        on:click={onRemove} />
    {/if}
  </td>
</tr>
<tr class="noline">
  <td class="info extra"><a href={'mailto:' + user.email}>{user.email}</a></td>
</tr>
<tr class="noline">
  <td class="info extra"><i>{user.institucion}</i></td>
</tr>
<tr class="noline last">
  <td class="info icons">
    {#if user.rol === 'EditorJefe'}
      <img title={dict['esEditorJefe']} src={userIcon} alt="User Icon" />
    {/if}
    {#if user.rol === 'Editor'}
      <img title={dict['esEditor']} src={userIcon} alt="User Icon" />
    {/if}
    {#if user.esRevisor}
      <img
        title={dict['esRevisor']}
        src="/images/revista/eye.svg"
        alt="Eye Icon" />
    {/if}
  </td>
</tr>
